<template lang="pug">
  
  div
    MHeader(
      page-title="Create Narrative"
      v-bind:breadcrumbs="breadcrumbs"
    )
    div( class="wrapper wrapper-content" )
      .back-page
        router-link( to="/narrative-management" )
          i( class="fa fa-angle-left" )
          | &nbsp;Back to Narrative Management

      div( class="ibox" )
        div( class="ibox-title" )
          strong Create New Narrative
            
        div( v-if="loading" class="ibox-content" ) Loading...
        div( v-else class="ibox-content" )
          div( class="form-group row" )
            label( class="col-sm-2 col-form-label" ) Type
            div( class="col-sm-10" )
              select( class="form-control" v-model="narrativeForm.type" )
                option( value="PROBLEM_AREA" ) Problem Area
                option( value="PROBLEM" ) Problem
                option( value="WHY" ) Why
                option( value="HOW" ) How
                option( value="HANDOVER_IMPACT" ) Handover Impact
          
          div( class="form-group row" )
            label( class="col-sm-2 col-form-label" ) Moonpull ID
            div( class="col-sm-10" )
              input( class="form-control" type="text" v-model="narrativeForm.moonpullId" )

          div( class="form-group row" )
            label( class="col-sm-2 col-form-label" ) Name
            div( class="col-sm-10" )
              input( class="form-control" type="text" v-model="narrativeForm.name" )
          
          div( class="form-group row" v-if="narrativeForm.type === 'HANDOVER_IMPACT'" )
            label( class="col-sm-2 col-form-label" ) Handover Impact Value
            div( class="col-sm-10" )
              input( class="form-control" type="text" v-model="narrativeForm.handoverImpactValue" )

          div( class="hr-line-dashed" )
          p
            strong Network Specific Narratives

          div( class="form-group row" v-for="network in narrativeForm.descriptions" )
            label( class="col-sm-2 col-form-label" )
              | {{ network.network }}
              template( v-if="network.network !== 'Default'" )
                div( class="switch" )
                  div( class="onoffswitch" )
                    input( class="onoffswitch-checkbox" type="checkbox" v-bind:id="`network-toggle-${network.network}`" v-on:click="network.enabled = !network.enabled" )
                    label( class="onoffswitch-label" v-bind:for="`network-toggle-${network.network}`" )
                      span( class="onoffswitch-inner" )
                      span( class="onoffswitch-switch" )

            div( v-if="network.enabled" class="col-sm-10" )
              textarea(
                class="form-control"
                v-bind:placeholder="network.network === 'Default' ? `Default description for this narrative` : `Network-specific description for this narrative`"
                v-model="network.description"
              ) {{ network.description }}
          
          div( class="row" )
            div( class="col-12 text-right" )
              button( class="btn btn-primary" v-on:click="createNarrative" ) Create

</template>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
export default Vue.extend({
  
  data() {
    return {
      breadcrumbs: [
        { label: 'Home', link: '/' },
        { label: 'Narrative Management', link: '/narrative-management' },
        { label: 'Create New Narrative', link: '/narrative-management/create' },
      ],
      loading: true,
      narrativeForm: {
        descriptions: []
      },
      networks: []
    }
  },

  methods: {

    async createNarrative() {

      const record = {
        type: this.narrativeForm.type,
        moonpullId: this.narrativeForm.moonpullId,
        name: this.narrativeForm.name,
        descriptions: this.narrativeForm.descriptions,
        handoverImpactValue: (this.narrativeForm.handoverImpactValue !== null) ? Number(this.narrativeForm.handoverImpactValue) : null,
      }

      try {
        const { data: { narrativeCreateOne: { id } } } = await this.$apollo.mutate({
          mutation: gql`
            mutation CreateNarrative($record: NarrativeNewInput!) {
              narrativeCreateOne(record: $record) {
                id
              }
            }
          `,
          variables: {
            record,
          },
        })
        this.$store.dispatch('flashMessage', { type: 'success', msg: `Successfully updated narrative` })
        this.$router.push({
          name: 'update-narrative',
          params: {
            narrativeId: id
          },
        })
      } catch (e) {
        this.$store.dispatch('flashMessage', { type: 'danger', msg: `Unexpected error: ${e.message}` })
      }
    }

  },

  async beforeMount() {
    this.networks = await this.$moonpull.getNetworks(this.$apollo)
    this.narrativeForm.descriptions.push({ network: 'Default', description: '', enabled: true })
    this.networks.forEach(network => {
      this.narrativeForm.descriptions.push({ network: network.name, description: '', enabled: false })
    })
    this.loading = false
  }

})
</script>